import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export type ProductAtomType = {
  status: { fetch: StatusType, create: StatusType, update: StatusType, delete: StatusType };
  list: Array<object>;
  data: object;
  error: object;
}

export const inventoryAtom = atom<ProductAtomType>({
  key: 'productAtom',
  default: {
    status: {
      fetch: 'idle',
      create: 'idle',
      update: 'idle',
      delete: 'idle',
    },
    list: [],
    data: {},
    error: {}
  },
});

export type CategoryAtomType = {
  status: { fetch: StatusType, create: StatusType, update: StatusType, delete: StatusType };
  list: Array<object>;
  data: object;
  error: object;
}

export const categoryAtom = atom<CategoryAtomType>({
  key: 'categoryAtom',
  default: {
    status: {
      fetch: 'idle',
      create: 'idle',
      update: 'idle',
      delete: 'idle',
    },
    list: [],
    data: {},
    error: {}
  },
});

interface ProductSectionListAtomPayload {
  status: { fetchList: StatusType };
  list: Array<any>;
  data: any;
  error: any;
}

export const bestDealsAtom = atom<ProductSectionListAtomPayload>({
  key: 'bestDealsAtom',
  default: {
    status: {
      fetchList: 'idle',
    },
    list: [],
    data: {},
    error: {}
  },
});

export const hotSellingItemsAtom = atom<ProductSectionListAtomPayload>({
  key: 'hotSellingItemsAtom',
  default: {
    status: {
      fetchList: 'idle',
    },
    list: [],
    data: {},
    error: {}
  },
});




